import React, { useEffect, useState } from "react";
import { InspectorEditableBlock } from "../../apps/Bundles/CommonFields/InspectorEditableBlock";

type Props_Timer = {
    countdown_timer_minutes: number;
    countdown_timer_text: string;
    timer_color: string;
    timer_text_color: string;
    timer_background_color: string;
    timer_font_style: any;
    timer_font_size: number;
    bundleType: string | undefined;
};

const CountdownTimer = ({
    countdown_timer_minutes,
    countdown_timer_text,
    timer_color,
    timer_text_color,
    timer_background_color,
    timer_font_style,
    timer_font_size,
    bundleType,
}: Props_Timer) => {
    const [showTimer, setShowTimer] = useState(true);

    const handleExpire = () => {
        setShowTimer(false); // Hide when timer ends
    };
    useEffect(() => {
        if (countdown_timer_minutes > 0) {
            setShowTimer(true);
        }
    }, [countdown_timer_minutes]);

    const renderTextWithTimer = (text: string) => {
        const parts = text.split("{timer}");

        // If there are no occurrences of {timer}, return the original text
        if (parts.length === 1) {
            return <span>{text}</span>;
        }

        return parts.map((part, index) => (
            <React.Fragment key={index}>
                <span>{part}</span>
                {index < parts.length - 1 && (
                    <Timer
                        initialMinutes={countdown_timer_minutes}
                        countdown_text_size={timer_font_size}
                        timer_color={timer_color}
                        onExpire={handleExpire}
                    />
                )}
            </React.Fragment>
        ));
    };

    if (!showTimer) return null;

    return (
        <InspectorEditableBlock bundleType={bundleType} settingKey="countdownTimer">
            <div
                style={{
                    paddingBottom: "10px",
                    paddingTop: "2px",
                }}
            >
                <p
                    style={{
                        textAlign: "center",
                        color: timer_text_color,
                        fontSize: timer_font_size,
                        backgroundColor: timer_background_color,
                        padding: "6px",
                        borderRadius: "5px",
                        fontWeight: timer_font_style?.split(" ")[0],
                        fontStyle: timer_font_style?.split(" ")[1],
                        wordBreak: "break-word",
                        margin: "0",
                    }}
                >
                    {renderTextWithTimer(countdown_timer_text)}
                </p>
            </div>
        </InspectorEditableBlock>
    );
};

export default CountdownTimer;

const Timer = ({
    initialMinutes,
    countdown_text_size,
    timer_color,
    onExpire,
}: {
    initialMinutes: number;
    countdown_text_size: number;
    timer_color: string;
    onExpire: () => void;
}) => {
    const isOverAnHour = initialMinutes > 60;

    const [timeLeft, setTimeLeft] = useState(() => {
        const hours = isOverAnHour ? Math.floor(initialMinutes / 60) : 0;
        const minutes = isOverAnHour ? initialMinutes % 60 : initialMinutes;
        return {
            hours,
            minutes,
            seconds: 0,
        };
    });

    useEffect(() => {
        const hours = isOverAnHour ? Math.floor(initialMinutes / 60) : 0;
        const minutes = isOverAnHour ? initialMinutes % 60 : initialMinutes;
        setTimeLeft({ hours, minutes, seconds: 0 });
    }, [initialMinutes, isOverAnHour]);

    useEffect(() => {
        const interval = setInterval(() => {
            setTimeLeft((prevTime) => {
                let { hours, minutes, seconds } = prevTime;

                if (seconds === 0) {
                    if (minutes === 0) {
                        if (hours === 0) {
                            clearInterval(interval);
                            onExpire();
                            return { hours: 0, minutes: 0, seconds: 0 };
                        } else {
                            hours -= 1;
                            minutes = 59;
                            seconds = 59;
                        }
                    } else {
                        minutes -= 1;
                        seconds = 59;
                    }
                } else {
                    seconds -= 1;
                }

                return { hours, minutes, seconds };
            });
        }, 1000);

        return () => clearInterval(interval);
    }, []);

    const formatTime = (time: number) => (time < 10 ? `0${time}` : time.toString());

    return (
        <span
            style={{
                fontSize: countdown_text_size,
                color: timer_color,
            }}
        >
            {isOverAnHour
                ? `${formatTime(timeLeft.hours)}:${formatTime(timeLeft.minutes)}:${formatTime(timeLeft.seconds)}`
                : `${formatTime(timeLeft.minutes)}:${formatTime(timeLeft.seconds)}`}
        </span>
    );
};
